$(document).ready(function () {

    var banotoOld = 0;
    var banotoNew = 0;

    $('.banoto').each(function (index, element) {
        $(element).addClass('d-none');
        if ($(element).hasClass("banoto-old") && banotoOld < 4) {
            $(element).removeClass('d-none');
            banotoOld++;
        }
        if ($(element).hasClass("banoto-new") && banotoNew < 4) {
            $(element).removeClass('d-none');
            banotoNew++;
        }
    });
    $('.show-all-listing').click(function () {
     //   $('.banoto').shuffle();
        banotoOld = 0;
        banotoNew = 0;
        $('.banoto').each(function (index, element) {
            $(element).addClass('d-none');
            if ($(element).hasClass("banoto-old") && banotoOld < 4) {
                $(element).removeClass('d-none');
                banotoOld++;
            }
            if ($(element).hasClass("banoto-new") && banotoNew < 4) {
                $(element).removeClass('d-none');
                banotoNew++;
            }

        })
    })
    $('.show-new-listing').click(function () {
       // $('.banoto').shuffle();

        banotoOld = 0;
        banotoNew = 0;
        $('.banoto').each(function (index, element) {
            $(element).addClass('d-none');
            if ($(element).hasClass("banoto-new") && banotoNew < 8) {
                $(element).removeClass('d-none');
                banotoNew++;
            }
        })
    })

    $('.show-old-listing').click(function () {
        //$('.banoto').shuffle();

        banotoOld = 0;
        banotoNew = 0;
        $('.banoto').each(function (index, element) {
            $(element).addClass('d-none');
            if ($(element).hasClass("banoto-old") && banotoOld < 8) {
                $(element).removeClass('d-none');
                banotoOld++;
            }
        })
    })

    $('table').each(function () {
        $(this).addClass('table').wrap('<div class="table-responsive"></div>');
    });

});


// WEBPACK FOOTER //
// ./resources/assets/js/custom.js